module.exports = __webpack_public_path__ + "fonts/KaTeX_AMS-Regular.10824af7.woff";